export enum ContractTypeRef {
    'AO CRE' = 'AO CRE',
    'CPPA FPI' = 'CPPA FPI',
}

export enum CaseTypeRef {
    'Bâtiments' = 'Bâtiments',
    'Cas 1 ou cas 2' = 'Cas 1 ou cas 2',
    'Cas 2 bis' = 'Cas 2 bis',
    'Cas 3' = 'Cas 3',
    'Eolien' = 'Eolien',
    '' = ''
}